import { Row, Container, Col } from 'styled-bootstrap-grid'
import { Wrapper, HeaderLogo } from './styles'
import logo from 'assets/images/logos/logo.svg'
import { useResolutions } from 'store/resolutions'
import Box from 'components/shared/Box'
import MobileSummary from './components/MobileSummary'
import SummaryPrice from './components/SummaryPrice'
import { toggleBodyScroll } from 'helpers/helpers'
import { useCart } from 'store/cart-slice/hooks'
import SelfcareDesktopNavigation from './components/SelfcareDesktopNavigation'
import CreatorDesktopNavigation from './components/CreatorDesktopNavigation'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { setIsMobileSummaryOpened } from 'store/general-slice'
import { useEffect } from 'react'
import { HOME_LINK } from 'constants/links'
import UnlimitedCardDesktopNavigation from './components/UnlimitedCardDesktopNavigation'
import steps from 'index'
import { useApp } from 'store/steps'
import UnlimitedRenewDesktopNavigation from './components/UnlimitedRenewDesktopNavigation'
import VouchersDesktopNavigation from './components/VouchersDesktopNavigation'
import { useTicketPromotions } from 'routes/Tickets/utils/useTicketPromotions'

const Header = () => {
    const { renderActivePromotions } = useTicketPromotions()
    const { isTablet } = useResolutions()
    const { isMobileSummaryOpened, appMode } = useAppSelector(
        (state) => state.general
    )
    const { countChanges, countNewItems } = useAppSelector(
        (state) => state.selfcareCart
    )
    const { stepIndex, isCreatorMode } = useApp()

    const { isAppAccessible } = useAppSelector((state) => state.general)
    const isScrollOff =
        document.documentElement.classList.contains('-modal-open')
    const { isCartEmpty } = useCart()

    useEffect(() => {
        if (isMobileSummaryOpened && !isScrollOff) {
            dispatch(setIsMobileSummaryOpened(!isMobileSummaryOpened))
        }
    }, [isScrollOff])

    const dispatch = useAppDispatch()

    const handleToggleSummary = () => {
        dispatch(setIsMobileSummaryOpened(!isMobileSummaryOpened))
        toggleBodyScroll()
    }

    const isCardConfigurationStep =
        stepIndex !== -1 && steps[stepIndex].id === 'card_configuration'
    const isCardRenewVerificationStep =
        stepIndex !== -1 && steps[stepIndex].id === 'renew_verification'

    const isCreatorSummaryVisible = isCreatorMode && !isCartEmpty
    const isSelfcareSummaryVisible =
        appMode === 'selfcare' && (countChanges > 0 || countNewItems > 0)
    const isUnlimitedSummaryVisible =
        appMode === 'unlimited-card' && !isCardConfigurationStep
    const isUnlimitedRenewSummaryVisible =
        appMode === 'unlimited-renew' &&
        !isCardRenewVerificationStep &&
        !isCartEmpty
    const isVouchersSummaryVisible = appMode === 'vouchers' && !isCartEmpty
    const isWithMobileSummary =
        isAppAccessible &&
        isTablet &&
        (isCreatorSummaryVisible ||
            isSelfcareSummaryVisible ||
            isUnlimitedSummaryVisible ||
            isUnlimitedRenewSummaryVisible ||
            isVouchersSummaryVisible)

    const isWithNavigation =
        isCreatorMode ||
        (appMode &&
            [
                'selfcare',
                'unlimited-card',
                'unlimited-renew',
                'vouchers',
            ].includes(appMode))

    return (
        <Wrapper id="header">
            <Container>
                <Row>
                    <Col>
                        <Box
                            direction="row"
                            align="center"
                            justify="space-between"
                        >
                            <a
                                href={HOME_LINK}
                                tabIndex={-1}
                                style={{ position: 'relative' }}
                            >
                                <HeaderLogo
                                    src={logo}
                                    alt="Park of Poland logo"
                                />
                                {renderActivePromotions({
                                    key: 'logoImage',
                                })}
                                {renderActivePromotions({
                                    key: 'logoImage',
                                    sectionType: 'unlimited',
                                })}
                            </a>

                            {isWithMobileSummary && !isMobileSummaryOpened && (
                                <SummaryPrice onClick={handleToggleSummary} />
                            )}
                        </Box>
                    </Col>
                </Row>
                {!isTablet && isAppAccessible && isWithNavigation && (
                    <Row>
                        <Col>
                            {isCreatorMode && <CreatorDesktopNavigation />}
                            {appMode === 'selfcare' && (
                                <SelfcareDesktopNavigation />
                            )}
                            {appMode === 'unlimited-card' && (
                                <UnlimitedCardDesktopNavigation />
                            )}
                            {appMode === 'unlimited-renew' && (
                                <UnlimitedRenewDesktopNavigation />
                            )}
                            {appMode === 'vouchers' && (
                                <VouchersDesktopNavigation />
                            )}
                        </Col>
                    </Row>
                )}
            </Container>
            {isWithMobileSummary && isMobileSummaryOpened && (
                <MobileSummary close={handleToggleSummary} />
            )}
        </Wrapper>
    )
}

export default Header
